/** Oxirgi ochilganlar: shu qurilmada ochilgan driver va carrier profillari -- tez qaytish uchun. */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Building2, History, UserRound } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Me } from "@/features/auth/types";
import type { WidgetItem } from "../types";
import { WidgetEmpty } from "../ui";
import { useRecent, type RecentEntry } from "./store";

type Props = { item: WidgetItem<Record<string, never>>; me: Me };

const hrefOf = (e: RecentEntry) => (e.kind === "driver" ? `/drivers/${e.id}` : `/carriers/${e.id}`);

export function RecentView({ item }: Props) {
  const { t } = useTranslation("widgets");
  const navigate = useNavigate();
  const list = useRecent();
  const shown = list.slice(0, item.size === "s" ? 3 : item.size === "m" ? 4 : 8);
  if (!shown.length) return <WidgetEmpty text={t("recent.empty")} />;
  const dense = item.size === "s";
  return (
    <div className={cn("flex h-full flex-col px-2 py-2", item.size === "l" && "overflow-y-auto")}>
      {!dense && <div className="mb-0.5 px-1.5 text-[11px] text-muted">{t("recent.title")}</div>}
      {shown.map((e) => {
        const Icon = e.kind === "driver" ? UserRound : Building2;
        return (
          <button key={`${e.kind}:${e.id}`} type="button" onClick={() => navigate(hrefOf(e))} className="flex w-full items-center gap-2 rounded-[8px] px-1.5 py-[3px] text-left transition-colors hover:bg-fill">
            <Icon size={14} strokeWidth={1.75} className="shrink-0 text-muted" aria-hidden />
            <span className="min-w-0 flex-1 leading-tight">
              <span className="block truncate text-[12px] font-medium">{e.title}</span>
              {!dense && e.subtitle && <span className="block truncate text-[11px] text-muted">{e.subtitle}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function RecentGlance() {
  const { t } = useTranslation("widgets");
  const last = useRecent()[0];
  return (
    <span className="inline-flex max-w-[160px] items-center gap-1.5" title={t("recent.title")}>
      <History size={13} strokeWidth={1.75} className="text-muted" aria-hidden />
      <span className={cn("truncate text-[12px]", last ? "font-medium" : "text-muted")}>{last ? last.title : t("recent.empty")}</span>
    </span>
  );
}
